import { WidgetJsonSchemaBase } from "./widget-json-schema.model"


export class ObjectJsonSchemaBase extends WidgetJsonSchemaBase {

    override type: string = 'object'
    properties: any = {}
    required: string [] = []
}

export interface ObjectJsonSchema extends ObjectJsonSchemaBase { }